import StyledLink from '../StyledLink'
import {
  ADD,
  MONITOR,
  MONITOR_CONFIG
} from '../routes'
import type { Props } from '../types'

const LinkToAddMonitorConfig = ({
  children,
  isHyperlink
}: Props) =>
  <StyledLink
    isHyperlink={isHyperlink}
    to={`/${MONITOR}/${MONITOR_CONFIG}/${ADD}`}

  >
    {children}
  </StyledLink>

export default LinkToAddMonitorConfig
